<template>
    <div>
        <div class="table-header row">
            <div>
                状态
            </div>
            <div>
                计算机名/IP
            </div>
            <div>分组</div>
            <div>
                开机时长
            </div>
            <div>
                上次开机时间
            </div>
            <div>操作</div>
        </div>
        <div class="table-body">
            <div class="row" v-for="(item, index) in listData" :key="index">
                <!-- 状态 -->
                <div>
                    <div v-if="remotingFlagArr.indexOf(item.flag) == -1">
                        <!-- 在线客户机 -->
                        <img v-show="item.isOnline&&!item.isSuper"
                        src=@/assets/img/icon/u1425.png />
                        <!-- 在线超级客户机 -->
                        <img v-show="item.isOnline&&item.isSuper"
                        src=@/assets/img/icon/client_super.png />
                        <!-- 离线客户机 -->
                        <img v-show="!item.isOnline"
                        src=@/assets/img/icon/u1429.png />
                    </div>
                    <!-- 远程中客户机 -->
                    <div v-if="remotingFlagArr.indexOf(item.flag) > -1">
                        <!-- 远程中服务器 -->
                        <img src=@/assets/img/icon/client_remoting.png />
                    </div>
                </div>
                <!-- 计算机名 -->
                <div class="computer-name">
                    <client-tag-hover-down :tag="item" style="height:24px;">
                        <div slot="hoverBtn">
                            <div>
                                <p
                                    class="one-line"
                                    style="overflow:hidden"
                                    v-text="$PropFn.safeDislayValue(item.name)"
                                ></p>
                            </div>
                        </div>
                    </client-tag-hover-down>
                    <p
                        class="one-line"
                        style="overflow:hidden;"
                        v-text="item.ip"
                    ></p>
                </div>
                <!-- 网吧分组名 -->
                <div>
                    <span v-text="item.groupName"></span>
                </div>
                <!-- 开机时长 -->
                <div>
                    <span
                        v-text="
                            onlineTimeMinSec(item.onlineTime, item.isOnline)
                        "
                    ></span>
                </div>
                <!-- 上次开机时间 -->
                <div class="ip-name">
                    <p v-text="showDate('Y-M-D', item.lastOpenTime * 1000)"></p>
                    <p v-text="showDate('h:m:s', item.lastOpenTime * 1000)"></p>
                </div>
                <div class="operate">
                    <a
                        href="#"
                        @click.prevent="
                            $WhdsRemoteProtocal.transferRemote(item, 0, 0, 1)
                        "
                        >极速控制</a
                    >
                    <a href="#" @click.prevent="colorControl(item)">
                        真彩控制<img
                            src="@/assets/img/icon/u44.png"
                            alt=""
                            style="width: 16px;position: relative;top: 5px;left: 1px;"
                        />
                    </a>
                    <a href="#" @click.prevent="viewingMode(item)">
                        观看模式<img
                            src="@/assets/img/icon/u43.png"
                            style="width: 16px;position: relative;top: 5px;left: 1px;"
                            alt=""
                            v-show="
                                $store.state.user.userInfo.judgeVip >= 1 &&
                                    $store.state.user.userInfo.vipStatus > 0
                            "
                        />
                    </a>
                    <a
                        href="#"
                        @click.prevent="
                            $WhdsRemoteProtocal.remoteCmd(
                                {
                                    barId: $route.params.id,
                                    flag: item.flag,
                                    local: item.ip,
                                    name: item.name,
                                    isOnline: item.isOnline
                                },
                                0
                            )
                        "
                        >远程命令</a
                    >
                    <word-down class="more-btn" :content="'更多'">
                        <div slot="down">
                            <div
                                class="drop-row"
                                @click="sendRemote('唤醒', item, 0, 10003)"
                            >
                                <span>唤醒计算机</span>
                            </div>
                            <div
                                class="drop-row"
                                @click="sendRemote('关闭', item, 0, 10001)"
                            >
                                <span>关闭计算机</span>
                            </div>
                            <div
                                class="drop-row"
                                @click="sendRemote('重启', item, 0, 10002)"
                            >
                                <span>重启计算机</span>
                            </div>
                        </div>
                    </word-down>
                </div>
            </div>
            <no-data
                style="height:auto;padding-top:20px;padding-bottom:20px;"
                :nodata="tableList.length == 0 && !loading"
                :loading="loading"
            ></no-data>
        </div>
    </div>
</template>

<script>
// 更多悬浮
import WordDown from "_c/dropdown/wordDown";
import { showDate } from "@/utils/time";
import { sendRemoteCommand } from "@/requests/bar";
import { mapGetters } from "vuex";
import ClientTagHoverDown from "_sc/clientTagHoverDown";
import NoData from "_c/noData/noData";
import { onlineTimeMinSec } from "_slib/time";

export default {
    name: "tableData",
    components: {
        WordDown,
        ClientTagHoverDown,
        NoData
    },
    props: {
        tableList: {
            type: Array,
            default() {
                return [];
            }
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isSelectAll: false,
            listData: []
        };
    },
    computed: {
        ...mapGetters({
            remotingFlagArr: "plugin/remotingFlagArr"
        })
    },
    watch: {
        tableList() {
            this.listData = this.tableList;
        }
    },
    methods: {
        showDate,
        sendRemoteCommand,
        sendRemote(content, item, i, cmdid) {
            if (item.name == null) {
                item.name = " -- ";
            }
            window.$Message.show({
                title: "是否" + content,
                type: "success",
                msgLeft: "你确认",
                msgCenter: content,
                msg: item.name + "(" + item.ip + ")" + "计算机吗？",
                cancleBtn: true,
                confirmFn: () => {
                    this.sendRemoteCommand(item, i, cmdid);
                    window.$Message.hide();
                }
            });
        },
        onlineTimeMinSec,
        colorControl(item) {
            if (
                this.$store.state.user.userInfo.judgeVip == 0 ||
                this.$store.state.user.userInfo.judgeVip == 2 ||
                (this.$store.state.user.userInfo.judgeVip == 1 &&
                    this.$store.state.user.userInfo.vipStatus == 0) ||
                (this.$store.state.user.userInfo.judgeVip == 3 &&
                    this.$store.state.user.userInfo.vipStatus == 0)
            ) {
                this.$router.push({
                    path: this.$PAGE_API.home.children.VIPInfo.path
                });
            } else {
                this.$WhdsRemoteProtocal.transferRemote(item, 0, 0, 2);
            }
        },
        viewingMode(item) {
            this.$WhdsRemoteProtocal.transferRemote(item, 0, 1, 3);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";
@import "_style/table/_default.scss";
@import "_style/cssfn/common.scss";

.row {
    width: 100%;
    @include clearfix();
    &:after {
        content: "";
        top: 0;
        left: 0;
        display: block;
        font-size: 0;
        height: 0;
        width: 0;
        clear: both;
        visibility: hidden;
    }
    > div {
        float: left;
        text-align: left;
        text-overflow: ellipsis;
        height: 50px;
        span {
            @include ellipsis();
            display: inline-block;
            max-width: 100%;
        }
        p {
            @include ellipsis();
            max-width: 100%;
            overflow: inherit;
        }
        a {
            text-align: left;
            text-indent: 0px;
            margin-right: 8px;
            color: #0066cc;
        }
        input {
            cursor: pointer;
        }
    }
    .more-btn {
        margin-left: 0;
    }

    > div:nth-child(1) {
        width: 10%;
        text-indent: 10px;
        input {
            position: relative;
            top: 2px;
        }
        overflow: hidden;
    }
    > div:nth-child(2) {
        width: 12%;
    }
    > div:nth-child(3) {
        width: 12%;
    }
    > div:nth-child(4) {
        width: 12%;
    }
    > div:nth-child(5) {
        width: 13%;
    }
    > div:nth-child(6) {
        width: 41%;
    }
}

.one-line {
    line-height: 14px;
}

.table-header {
    > div {
        height: 30px;
        line-height: 30px;
    }
}

.bar-name,
.ip-name {
    p {
        line-height: normal;
        line-height: 14px;
    }
    p:nth-child(1) {
        padding-top: 10px;
    }
}
.computer-name {
    line-height: 14px;
    > div {
        padding-top: 10px;
    }
    p:nth-child(1) {
        color: $blue-1;
    }
}

.server {
    .online {
        span {
            color: $green;
        }
    }
    .offline {
        span {
            color: $gray-word;
        }
    }
    img {
        position: relative;
        vertical-align: top;
        top: 18px;
        margin-right: 4px;
    }
}
.gray-color {
    color: $gray-word;
}
</style>
